import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import Filter from '../../Filter';

const DoorlockBatteryLogList = ({
  doorlockBatteryLogListItems,
  filterItem,
  setFilterItem,
  history,
}) => {
  const { t } = useTranslation();

  //디바운싱 사용 구분을 위해 debounce props 추가
  const changeFilterItem = (targetItem, debounce) => {
    setFilterItem({
      ...filterItem,
      ...targetItem,
    }, debounce);
  };

  const initFilterItem = () => {
    setFilterItem({
      startAt: moment().subtract(1, 'year').startOf('day').toDate(),
      endAt: moment().endOf('day').toDate(),
    });
  };

  return (
    <Fragment>
      <div className='content-chart-detail'>
        <div className='content-title'>
          <Filter
            columns={[
              {
                key: 'startAt',
                type: 'datePicker',
                placeholder: t('data_column.start_at'),
                value: filterItem.startAt,
                action: changeFilterItem,
                selectsStart: true,
                minDate: moment().subtract(1, 'year').startOf('day').toDate(),
                endDate: filterItem.endAt,
              },
              {
                key: 'endAt',
                type: 'datePicker',
                placeholder: t('data_column.end_at'),
                value: filterItem.endAt,
                action: changeFilterItem,
                selectsEnd: true,
                minDate: filterItem.startAt,
                startDate: filterItem.startAt,
                disabled: !filterItem.startAt,
              },
            ]}
            init={initFilterItem}
            customClassName={'detail-page'}
          />
        </div>
        <HighchartsReact
          highcharts={Highcharts}
          options={
            {
              chart: {
                backgroundColor: {
                  linearGradient: { x1: 0, y1: 0, x2: 1, y2: 1 },
                  stops: [
                    [0, '#282c34'],
                    [1, '#282c34'],
                  ],
                },
                style: {
                  fontFamily: '\'Unica One\', sans-serif'
                },
              },
              title: {
                text: t('content_title.battery_chart'),
                style: {
                  color: '#E6E5E8',
                  textTransform: 'uppercase',
                  fontSize: '20px',
                  fontWeight: 'bold',
                },
              },
              credits: {
                enabled: false,
              },
              xAxis: {
                categories: doorlockBatteryLogListItems.map((batteryLog) => moment(batteryLog.created_at).format('YYYY-MM-DD HH:mm:ss')),
                gridLineColor: '#707073',
                labels: {
                  style: {
                    color: '#E6E5E8',
                  },
                },
                lineColor: '#707073',
                minorGridLineColor: '#505053',
                tickColor: '#707073',
                title: {
                  style: {
                    color: '#A0A0A3',
                  },
                },
              },
              yAxis: {
                min: 0,
                max: 100,
                gridLineColor: '#707073',
                labels: {
                  style: {
                    color: '#E6E5E8',
                  },
                },
                lineColor: '#707073',
                minorGridLineColor: '#505053',
                tickColor: '#707073',
                title: {
                  text: '',
                  style: {
                    color: '#A0A0A3',
                  },
                },
              },
              tooltip: {
                backgroundColor: 'rgba(0, 0, 0, 0.85)',
                style: {
                  color: '#F0F0F0',
                },
              },
              legend: {
                itemStyle: {
                  color: '#E0E0E3'
                },
                itemHoverStyle: {
                  color: '#FFF'
                },
                itemHiddenStyle: {
                  color: '#606063'
                },
                title: {
                  style: {
                    color: '#C0C0C0'
                  }
                }
              },
              series: [{ name: t('button.battery'), data: doorlockBatteryLogListItems.map((batteryLog) => batteryLog.fw_battery) }]
            }
          }
        />
      </div>
    </Fragment>
  );
};

export default DoorlockBatteryLogList;